import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import i18n from '@/i18n/i18n'
import { notifyServerError } from '@/layouts/notifies'

let serviceDetails = null
const cTebMinAmount = 2500

const parseInvoiceRequest = invoice => {
  const [serviceTag, id] = invoice.requestId.split('@')
  // eslint-disable-next-line no-unused-vars
  const [serviceType, category, subject] = serviceTag.split(':')
  if (serviceType === 'health') {
    invoice.request = { id, category, subject }

    invoice.items.forEach(item => {
      const [more, name] = item.name.split('@')
      const [type, category, subject] = more.split(':')
      item.service_name = i18n.t(`health_services.${subject}.${name}`)
      item.service = name
      item.type = type
      item.category = category
      item.subject = subject
    })
    let wage = invoice.items.reduce(
      (accum, item) =>
        accum + (item.price * item.count * serviceDetails[item.subject][item.service].percent) / 100,
      0
    )
    if (wage < cTebMinAmount) wage = cTebMinAmount * 1.09 - wage
    else wage *= 0.09
    invoice.wage = Math.round(wage)

    invoice.totalPrice = Math.round(
      invoice.items.reduce((accum, item) => accum + item.price * item.count, 0) + wage
    )
  } else if (serviceType == 'reserve') {
    invoice.wage = 2500

    invoice.totalPrice = Math.round(
      invoice.items.reduce((accum, item) => accum + item.price * item.count, 0) + 2500
    )
  }
}

export default {
  createInvoice(context, invoiceData) {
    return new Promise((resolve, reject) => {
      axios
        .post('invoices', invoiceData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countInvoices(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`invoices/count/?${query}`)
        .then(response => {
          context.commit('SET_INVOICES_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchInvoices(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`invoices/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          serviceDetails = context.rootGetters['config/provinceServiceDetails']
          response.data.forEach(invoice => parseInvoiceRequest(invoice))
          context.commit('SET_INVOICES', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchUnpaidInvoices(context, payload = { skip: 0, limit: 0 }) {
    const query = QuerySerialize({ state: 'unpaid', owner: context.rootState.AppActiveUser.id })
    return new Promise((resolve, reject) => {
      axios
        .get(`invoices/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          serviceDetails = context.rootGetters['config/provinceServiceDetails']
          response.data.forEach(invoice => parseInvoiceRequest(invoice))
          context.commit('SET_UNPAID_INVOICES', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchInvoice(context, invoiceId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`invoices/${invoiceId}`)
        .then(response => {
          serviceDetails = context.rootGetters['config/provinceServiceDetails']
          parseInvoiceRequest(response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  cashInvoice(context, invoiceId) {
    return new Promise((resolve, reject) => {
      axios
        .put(`invoices/${invoiceId}/cash`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  updateCaseManagerItem(context, invoice) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`invoices/${invoice.id}/case-manager`, invoice.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeInvoice({ commit }, invoiceId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`invoices/${invoiceId}`)
        .then(response => {
          commit('REMOVE_RECORD', invoiceId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editInvoice(context, invoice) {
    return new Promise((resolve, reject) => {
      axios
        .put(`invoices/${invoice.id}`, invoice.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
